<div class="row mt-3 mb-3">
  <div class="col-12">
    <button (click)="adicionar()" [disabled]="disabled()" class="btn btn-sm btn-outline-primary" title="CTRL + I">
      <img src="assets/img/global/plus.png" alt="adicionar"  height="16" width="16">
      Adicionar
    </button>
  </div>
</div>
<table class="table table-eddy" *ngIf="lista && lista.length > 0">
  <thead>
    <tr>
      <th style="width: 15%" scope="col">CPF</th>
      <th style="width: 40%" scope="col">Presidente</th>
      <th style="width: 15%" scope="col" class="text-center">Início Mandato</th>
      <th style="width: 15%" scope="col" class="text-center">Fim Mandato</th>
      <th style="width: 120px" scope="col"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of lista; let idx = index">
      <td style="width: 10%" *ngIf="!item.editavel">{{item?.presidente?.cpf_cnpj | CPF}}</td>
      <td *ngIf="!item.editavel" style="width: 40%">{{item.presidente.nome}}</td>
      <td *ngIf="item.editavel" style="width: 40%" [attr.colspan]="item.editavel ? '2' : '1'">
        <p-autoComplete [(ngModel)]="item.presidente" [field]="pessoaAutoComplete.conversor"
          [suggestions]="pessoaAutoComplete.lista" (completeMethod)="pessoaAutoComplete.filtrar($event)"
          placeholder="Informe cpf/cnpj ou nome/razão social"
          inputStyleClass="form-control autocomplete-radius-right" minLength="2"
          [style]="{ width: 'calc(100% - 46px)', float: 'left' }" [forceSelection]="true" [autoHighlight]="true"
          *ngIf="pessoaAutoComplete">
          <ng-template let-pessoa pTemplate="item">
            {{pessoa.cpf_cnpj | CPF}} {{pessoa.nome}}
          </ng-template>
        </p-autoComplete>
        <button class="btn btn-outline-secondary float-right" type="button" (click)="cadastroPessoa(item)"
          style="height: 36px; border-bottom-left-radius: 0px;  border-top-left-radius: 0px;">
          <i class="fa fa-user-plus"></i>
        </button>
      </td>

      <td *ngIf="!item.editavel" class="text-center" style="width: 15%"> {{item.dt_inicio_mandato | date:'dd/MM/yyyy':'GMT'}} </td>
      <td *ngIf="!item.editavel" class="text-center" style="width: 15%"> {{item.dt_fim_mandato | date:'dd/MM/yyyy':'GMT'}} </td>

      <td *ngIf="item.editavel" style="width: 15%">
        <p-calendar [(ngModel)]="item.dt_inicio_mandato" inputStyleClass="form-control" dataType="date"
          dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false" [showButtonBar]="true"
          [style]="{ width: '100%' }">
        </p-calendar>
      </td>
      <td *ngIf="item.editavel" style="width: 15%">
        <p-calendar [(ngModel)]="item.dt_fim_mandato" inputStyleClass="form-control" dataType="date"
          dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false" [showButtonBar]="true"
          [style]="{ width: '100%' }">
        </p-calendar>
      </td>

      <td class="text-right" style="width: 120px;">
        <button *ngIf="item.editavel" (click)="salvar(item)" class="btn btn-sm btn-outline-secondary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel" (click)="cancelar(item, idx)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="editar(item)" [disabled]="disabled()"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="remover(item, idx)" [disabled]="disabled()"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>